export default __webpack_public_path__ + "static/SRUS P330 - Especification Del Producto y Datos Técnicos-c24d5f70993faa0470f5f1c9b7d28142.pdf";